export enum ARInvoiceStatus {
	Open = 1,
	PartialPaid = 2,
	Paid = 3,
	Closed = 4,
}
